import DestructorTree from "../DestructorTree";
import { client_state } from "./ClientState";
import { lambda } from "../../../../../stream";
import { toStream } from "../toStream";

export function subscribeToTranslation(
	phrase: string,
	destructor: DestructorTree,
	callback: (translation: string) => void,
	returnInitialValue = true
) {
	destructor.subscribeToText(
		client_state,
		"subscribe_selected_language",
		() => {
			callback(getTranslation(phrase));
		},
		returnInitialValue
	);
}

export function getTranslation(phrase: string): string {
	return (
		client_state.properties.selected_language.ref.key.ref.properties.translations.get(phrase)?.properties.translation ??
		phrase
	);
}

export const translate = lambda((phrase: string) =>
	toStream(client_state, "selected_language").pipe(() => getTranslation(phrase))()
);
